<script>
import { EventBus } from "../event-bus";

export default {
  data() {
    return {
      prevReportUploadObj: { testId: "", testName: "", files: [] },
      consentUploadObj: { testId: "", testName: "", files: [] },
    };
  },
  watch: {
    prevReportUploadObj: {
      handler(newUploadObj) {
        EventBus.$emit("updateUploadFiles", newUploadObj, "previousReport");
      },
      deep: true,
    },
    consentUploadObj: {
      handler(newUploadObj) {
        EventBus.$emit("updateUploadFiles", newUploadObj, "consent");
      },
      deep: true,
    },
  },
  methods: {
    updateUploadObj(uploadObj, uploadType) {
      switch (uploadType) {
        case "previousReport":
          this.prevReportUploadObj = { ...uploadObj };
          return;
        case "consent":
          this.consentUploadObj = {
            ...uploadObj,
          };
          return;
      }
    },
  },
};
</script>
